export const TEXT_KEYS = {
    STATUS: 'dashboard-page__status',
    REWARD_DESCRIPTION: 'invitee-page__reward-description',
};

export const DEFAULT_STAT_VALUE = '0';
